import { render } from "./UpdateTaskTypePage.vue?vue&type=template&id=094030ca&ts=true"
import script from "./UpdateTaskTypePage.vue?vue&type=script&lang=ts"
export * from "./UpdateTaskTypePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__